export class Shipment {

    private dtimeInserted: number;
    private dtimeUpdated: number;
    private payerCountry: string | null;
    private cpaKey: string;
    private ddPid: string;
    private account: string | null;
    private invoiceDate: number;
    private invoiceId: string;
    private shipmentDate: number | null;
    private waybillNumber: string | null;
    private uniqueId: string;
    private billableWeight: string | null;
    private businessType: string | null;
    private productCode: string | null;
    private grossUndiscountedCharge: number | null;
    private adjustedDiscountedCharge: number | null;
    private discountPercent: number | null;
    private discountAmount: number | null;
    private discountPid: string | null;
    private debitOrCredit: string | null;
    private originCountry: string | null;
    private originServiceArea: string | null;
    private originCity: string | null;
    private originPostalCode: string | null;
    private destinationCountry: string | null;
    private destinationServiceArea: string | null;
    private destinationCity: string | null;
    private destinationPostalCode: string | null;
    private noOfPieces: string | null;
    private marketedProductId: string | null;
    private currencyCode: string | null;

    constructor(raw: any) {
        if (raw) {
            this.setDtimeInserted(raw.DTIME_INSERTED);
            this.setDtimeUpdated(raw.DTIME_UPDATED);
            this.setPayerCountry(raw.PAYER_COUNTRY);
            this.setCpaKey(raw.CPA_KEY);
            this.setDdPid(raw.DD_PID);
            this.setAccount(raw.ACCOUNT);
            this.setInvoiceDate(raw.INVOICE_DATE);
            this.setInvoiceId(raw.INVOICE_ID);
            this.setShipmentDate(raw.SHIPMENT_DATE);
            this.setWaybillNumber(raw.WAYBILL_NUMBER);
            this.setUniqueId(raw.UNIQUE_ID);
            this.setBillableWeight(raw.BILLABLE_WEIGHT);
            this.setBusinessType(raw.BUSINESS_TYPE);
            this.setProductCode(raw.PRODUCT_CODE);
            this.setGrossUndiscountedCharge(raw.GROSS_UNDISCOUNTED_CHARGE);
            this.setAdjustedDiscountedCharge(raw.ADJUSTED_DISCOUNTED_CHARGE);
            this.setDiscountPercent(raw.DISCOUNT_PERCENT);
            this.setDiscountAmount(raw.DISCOUNT_AMOUNT);
            this.setDiscountPid(raw.DISCOUNT_PID);
            this.setDebitOrCredit(raw.DEBIT_OR_CREDIT);
            this.setOriginCountry(raw.ORIGIN_COUNTRY);
            this.setOriginServiceArea(raw.ORIGIN_SERVICE_AREA);
            this.setOriginCity(raw.ORIGIN_CITY);
            this.setOriginPostalCode(raw.ORIGIN_POSTAL_CODE);
            this.setDestinationCountry(raw.DESTINATION_COUNTRY);
            this.setDestinationServiceArea(raw.DESTINATION_SERVICE_AREA);
            this.setDestinationCity(raw.DESTINATION_CITY);
            this.setDestinationPostalCode(raw.DESTINATION_POSTAL_CODE);
            this.setNoOfPieces(raw.NO_OF_PIECES);
            this.setMarketedProductId(raw.MARKETED_PRODUCT_ID);
            this.setCurrencyCode(raw.CURRENCY_CODE);
        }
    }

    public getDtimeInserted(): number {
        return this.dtimeInserted;
    }

    public setDtimeInserted(dtimeInserted: number): void {
        this.dtimeInserted = dtimeInserted;
    }

    public getDtimeUpdated(): number {
        return this.dtimeUpdated;
    }

    public setDtimeUpdated(dtimeUpdated: number): void {
        this.dtimeUpdated = dtimeUpdated;
    }

    public getPayerCountry(): string | null {
        return this.payerCountry;
    }

    public setPayerCountry(payerCountry: string | null): void {
        this.payerCountry = payerCountry;
    }

    public getCpaKey(): string {
        return this.cpaKey;
    }

    public setCpaKey(cpaKey: string): void {
        this.cpaKey = cpaKey;
    }

    public getDdPid(): string {
        return this.ddPid;
    }

    public setDdPid(ddPid: string): void {
        this.ddPid = ddPid;
    }

    public getAccount(): string | null {
        return this.account;
    }

    public setAccount(account: string | null): void {
        this.account = account;
    }

    public getInvoiceDate(): number {
        return this.invoiceDate;
    }

    public setInvoiceDate(invoiceDate: number): void {
        this.invoiceDate = invoiceDate;
    }

    public getInvoiceId(): string {
        return this.invoiceId;
    }

    public setInvoiceId(invoiceId: string): void {
        this.invoiceId = invoiceId;
    }

    public getShipmentDate(): number | null {
        return this.shipmentDate;
    }

    public setShipmentDate(shipmentDate: number | null): void {
        this.shipmentDate = shipmentDate;
    }

    public getWaybillNumber(): string | null {
        return this.waybillNumber;
    }

    public setWaybillNumber(waybillNumber: string | null): void {
        this.waybillNumber = waybillNumber;
    }

    public getUniqueId(): string {
        return this.uniqueId;
    }

    public setUniqueId(uniqueId: string): void {
        this.uniqueId = uniqueId;
    }

    public getBillableWeight(): string | null {
        return this.billableWeight;
    }

    public setBillableWeight(billableWeight: string | null): void {
        this.billableWeight = billableWeight;
    }

    public getBusinessType(): string | null {
        return this.businessType;
    }

    public setBusinessType(businessType: string | null): void {
        this.businessType = businessType;
    }

    public getProductCode(): string | null {
        return this.productCode;
    }

    public setProductCode(productCode: string | null): void {
        this.productCode = productCode;
    }

    public getGrossUndiscountedCharge(): number | null {
        return this.grossUndiscountedCharge;
    }

    public setGrossUndiscountedCharge(grossUndiscountedCharge: number | null): void {
        this.grossUndiscountedCharge = grossUndiscountedCharge;
    }

    public getAdjustedDiscountedCharge(): number | null {
        return this.adjustedDiscountedCharge;
    }

    public setAdjustedDiscountedCharge(adjustedDiscountedCharge: number | null): void {
        this.adjustedDiscountedCharge = adjustedDiscountedCharge;
    }

    public getDiscountPercent(): number | null {
        return this.discountPercent;
    }

    public setDiscountPercent(discountPercent: number | null): void {
        this.discountPercent = discountPercent;
    }

    public getDiscountAmount(): number | null {
        return this.discountAmount;
    }

    public setDiscountAmount(discountAmount: number | null): void {
        this.discountAmount = discountAmount;
    }

    public getDiscountPid(): string | null {
        return this.discountPid;
    }

    public setDiscountPid(discountPid: string | null): void {
        this.discountPid = discountPid;
    }

    public getDebitOrCredit(): string | null {
        return this.debitOrCredit;
    }

    public setDebitOrCredit(debitOrCredit: string | null): void {
        this.debitOrCredit = debitOrCredit;
    }

    public getOriginCountry(): string | null {
        return this.originCountry;
    }

    public setOriginCountry(originCountry: string | null): void {
        this.originCountry = originCountry;
    }

    public getOriginServiceArea(): string | null {
        return this.originServiceArea;
    }

    public setOriginServiceArea(originServiceArea: string | null): void {
        this.originServiceArea = originServiceArea;
    }

    public getOriginCity(): string | null {
        return this.originCity;
    }

    public setOriginCity(originCity: string | null): void {
        this.originCity = originCity;
    }

    public getOriginPostalCode(): string | null {
        return this.originPostalCode;
    }

    public setOriginPostalCode(originPostalCode: string | null): void {
        this.originPostalCode = originPostalCode;
    }

    public getDestinationCountry(): string | null {
        return this.destinationCountry;
    }

    public setDestinationCountry(destinationCountry: string | null): void {
        this.destinationCountry = destinationCountry;
    }

    public getDestinationServiceArea(): string | null {
        return this.destinationServiceArea;
    }

    public setDestinationServiceArea(destinationServiceArea: string | null): void {
        this.destinationServiceArea = destinationServiceArea;
    }

    public getDestinationCity(): string | null {
        return this.destinationCity;
    }

    public setDestinationCity(destinationCity: string | null): void {
        this.destinationCity = destinationCity;
    }

    public getDestinationPostalCode(): string | null {
        return this.destinationPostalCode;
    }

    public setDestinationPostalCode(destinationPostalCode: string | null): void {
        this.destinationPostalCode = destinationPostalCode;
    }

    public getNoOfPieces(): string | null {
        return this.noOfPieces;
    }

    public setNoOfPieces(noOfPieces: string | null): void {
        this.noOfPieces = noOfPieces;
    }

    public getMarketedProductId(): string | null {
        return this.marketedProductId;
    }

    public setMarketedProductId(marketedProductId: string | null): void {
        this.marketedProductId = marketedProductId;
    }

    public getCurrencyCode(): string | null {
        return this.currencyCode;
    }

    public setCurrencyCode(currencyCode: string | null): void {
        this.currencyCode = currencyCode;
    }
}